import { FormattedMessage, IntlProvider } from "react-intl";
import { useContext } from "react";
import { LangContext } from "../App";
import Messages from "../translate/Messages";

export default function NotFound() {
  const language = useContext(LangContext);
  return (
    <div className="bodyBackground">
      <IntlProvider locale={language} messages={Messages[language]}>
        <h2>
          <FormattedMessage id="pagenotfound" />
        </h2>
      </IntlProvider>
    </div>
  );
}
